import React, { useEffect, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { TabsHistory } from '../../../app/components/TabsHistory';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { GetClientDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { EmailAddressTab } from '../../components/EmailAddress/EmailAddressTab';
import { useTranslation } from '../../../common/hooks/useTranslation';

type ParamTypes = {
  clientId: string;
};

export const ClientEmailsView: React.FC = () => {
  const [client, setClient] = useState<GetClientDto>();

  const { clientId } = useParams<ParamTypes>() as {
    clientId: string;
  };
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('clientLng');

  useEffect(() => {
    pok.clients
      .getById(clientId)
      .then(client => {
        setClient(client);
      })
      .catch(errorResponse => {
        notifications.caughtError(errorResponse);
      });
  }, [clientId, notifications, pok.clients]);

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">
          <span
            style={
              client?.active === false ? { textDecoration: 'line-through' } : {}
            }
          >
            {t(tk.client.client)} <b>{client?.name}</b>
            {client
              ? `, ${t(tk.common.sysNumberLowerCase)} ${client.systemNumber}`
              : null}
          </span>
        </Card.Title>
        {client && (
          <TabsHistory
            activeKey="emailAddress"
            id="product"
            className="mb-3"
            mountOnEnter={true}
            unmountOnExit={true}
          >
            <Tab
              eventKey="emailAddress"
              title={t(tk.client.emailAddresses)}
              className="m-3"
            >
              <EmailAddressTab clientId={client.id} client={client} />
            </Tab>
          </TabsHistory>
        )}
      </Card.Body>
    </Card>
  );
};
